import { defineStore } from 'pinia';
import { staticRoutes, dynamicRoutes } from '@/router/routerConfig';

/**
 * 判断当前用户是否拥有某个路由的访问权限
 * @param {{role: string, deptType: number}} userRole 当前用户角色和单位类型
 * @param {Object} route 单个路由
 * @returns {boolean}
 */
const hasPermission = (userRole, route) => {
  if (route.meta) {
    let isAuth = true;
    if (route.meta.roles && route.meta.roles.length > 0) {
      isAuth = route.meta.roles.includes(userRole.role);
    }
    if (route.meta.deptTypes && route.meta.deptTypes.length > 0) {
      isAuth = route.meta.deptTypes.includes(userRole.deptType);
    }
    return isAuth;
  }
  return true;
};
/**
 * 根据用户角色和单位类型，生成对应的动态路由，解决多级路由缓存失败问题
 * @param {{role: string, deptType: number}} userRole 当前用户角色和单位类型
 * @param {Object[]} routes 初始动态路由列表
 */
const filterDynamicRoutes = (routes, userRole) => {
  const result = [];
  routes.forEach((r) => {
    if (hasPermission(userRole, r)) {
      if (r.children && r.children.length > 0) {
        r.children = filterDynamicRoutes(r.children, userRole);
      }
      result.push(r);
    }
  })
  return result;
};

/**
 * 数组扁平化：多级嵌套数组处理成一维数组，使keepAlive能够缓存每个路由
 * @param arr 传入路由菜单数据数组
 * @returns 返回处理后的一维路由菜单数组
 */
const formatFlatteningRoutes = (arr) => {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].children) {
      const temp = arr[i].children;
      arr[i].children = [];
      arr = arr.slice(0, i + 1).concat(temp, arr.slice(i + 1));
    }
  }
  return arr;
};

export const usePremissionStore = defineStore('premission', {
  state: () => ({
    menus: [], // 全局菜单结构
    routes: [],
    addRoutes: [],
  }),
  actions: {
    generateRoutes (userRole) {
      const noFound = [{ path: '/:path(.*)*', redirect: '/404'}];
      return new Promise((resolve, reject) => {
        // 路由权限过滤
        const accessedRoutes = filterDynamicRoutes(dynamicRoutes, userRole);
        this.menus = JSON.parse(JSON.stringify(accessedRoutes[0].children)); // 深克隆
        // 路由扁平化
        this.addRoutes = [
          {
            ...accessedRoutes[0],
            children: formatFlatteningRoutes(accessedRoutes[0].children),
          },
          ...noFound,
        ];
        // 默认重定向到第一个子路由
        this.addRoutes[0].redirect = this.addRoutes[0].children[0].path;
        this.routes = staticRoutes.concat(this.addRoutes);
        resolve(this.addRoutes);
      });
    },
  },
});


// WEBPACK FOOTER //
// ./src/pinia/permission.js